// extracted by mini-css-extract-plugin
export default {"container":"region-group-overview_container__ksmnG","header":"region-group-overview_header__pftC9"};